import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// In Vite, environment variables must be prefixed with VITE_ instead of REACT_APP_
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAHh9DRJbFpaNvGjbFID6c4IR_ykuARRxs",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "naim-app-d0nvh.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "naim-app-d0nvh",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "naim-app-d0nvh.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "112268054413",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:112268054413:web:ac045a410dae50294977c4",
};

// TODO: Replace environment variables in .env file with actual Firebase configuration values
// You'll need to create a Firebase project and get these values from the Firebase console

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;